exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-300 {\n\twidth: 300px !important;\n}\n", ""]);

// exports
